export const CategoryHead = ["Name", "Description", "Action"];
